module.exports = __webpack_public_path__ + "static/media/HeroImage.72cbb69e.PNG";